<app-tooltip-template label="select.metrics" *ngIf="params.metrics?.length">
  <app-source [item]="metric" [width]="15" *ngFor="let metric of params.metrics"></app-source>
</app-tooltip-template>
